// @ts-nocheck
export const field = {
	context: 'legalRequest',
	fields: [
		{
			label: 'Fase',
			error: [],
			required: true,
			labeled: false,
			contentEditable: false,
			entityKey: 'selectNewPhase',
			auxEntity: {
				entityUrl: '/task/drop-data',
				tableName: 'phase',
			},
			value: null,
		},
		{
			entityKey: 'oldPhases',
			type: 'checkbox',
			value: true,
		},
		{
			size: 7,
			label: 'Selecione o tipo de pedido:',
			entityKey: 'typeId',
			error: [],
			type: 'SELECT_TREE',
			bibEntity: {
				context: 'ecfe7690-90b2-11eb-8379-9b62dbd2ab82',
				// context: "bd5fc1fe-3b48-11ed-a261-0242ac120002",
				entityUrl: '/legal-request/type',
			},
			breadcrumbEntity: {
				entityUrl: '/legal-request/type/all',
			},
			required: true,
			value: null,
		},
		{
			size: 2,
			entityKey: 'typeLabel',
			label: 'Pedido',
			type: 'TEXT',
			required: false,
			value: null,
		},
		{
			auxEntity: {
				listOptions: [
					{
						value: 'autor',
						label: 'Autor',
					},
					{
						value: 'reu',
						label: 'Réu',
					},
				],
			},
			size: 2,
			entityKey: 'part',
			disabled: true,
			label: 'Parte',
			type: 'SELECT_ONE',
			error: [],
			required: true,
			editable: false,
			value: null,
		},
		{
			size: 3,
			entityKey: 'dateReference',
			disabled: true,
			label: 'Data de referência',
			rules: ['du<d'],
			error: [],
			type: 'CALENDAR',
			required: true,
			editable: false,
			value: null,
		},
		{
			auxEntity: {
				entityUrl: '/task/drop-data',
				tableName: 'risk',
			},
			size: 2,
			entityKey: 'risk',
			disabled: true,
			label: 'Risco',
			type: 'SELECT_ONE',
			error: [],
			required: true,
			editable: false,
			value: null,
		},
		{
			value: null,
			required: true,
			error: [],
			type: 'TEXTAREA',
			entityKey: 'description',
			label: 'Pedido',
			size: 7,
		},
		{
			type: 'ADDITIONAL_VALUES',
			size: 7,
			fields: [
				{
					label: 'Principal',
					required: true,
					enabled: true,
					entityKey: 'hasPrimary',
					error: [],
					fields: [
						[
							{
								size: 3,
								entityKey: 'primaryValue',
								disabled: false,
								label: 'Valor Inicial',
								error: [],
								type: 'TEXT',
								mask: 'CURRENCY_BR',
								required: true,
								editable: false,
								value: null,
							},
							{
								auxEntity: {
									entityUrl: '/legal-request/getIndexes',
									tableName: 'legal-request-indexes',
								},
								size: 3,
								entityKey: 'primaryIndexId',
								disabled: true,
								label: 'Índice de Correção',
								type: 'SELECT_ONE',
								error: [],
								required: true,
								editable: true,
								value: null,
							},
						],
					],
				},
				{
					label: 'Juros',
					enabled: false,
					required: true,
					error: [],
					entityKey: 'hasInterest',
					fields: [
						[
							{
								auxEntity: {
									entityUrl: '/task/drop-data',
									tableName: 'interest',
								},
								size: 7,
								entityKey: 'interestType',
								disabled: true,
								label: 'Tipo de Juros',
								type: 'RADIO',
								forceType: 'RADIO',
								error: [],
								required: false,
								editable: true,
								value: null,
							},
						],
						[
							{
								size: 3,
								entityKey: 'interestDateReference',
								disabled: true,
								label: 'Data de referência',
								rules: ['du<d'],
								error: [],
								type: 'CALENDAR',
								required: false,
								editable: false,
								value: null,
							},
							{
								size: 2,
								entityKey: 'interestPercents',
								disabled: true,
								label: 'Porcentagem',
								mask: 'PERCENTS_v2',
								type: 'TEXT',
								required: false,
								editable: false,
								value: null,
							},
						],
					],
				},
				{
					label: 'Multa',
					enabled: false,
					required: true,
					entityKey: 'hasPenalty',
					error: [],
					fields: [
						[
							{
								size: 2,
								entityKey: 'penaltyPercents',
								disabled: false,
								label: 'Porcentagem',
								error: [],
								type: 'TEXT',
								mask: 'PERCENTS_v2',
								required: false,
								editable: false,
								value: null,
							},
						],
					],
				},
			],
		},
		{
			auxEntity: {
				listOptions: [
					{
						value: 'true',
						label: 'Incluir pedido até a fase atual',
					},
				],
			},
			size: 1,
			entityKey: 'faseatual',
			disabled: true,
			type: 'SELECT_LIST',
			error: [],
			required: false,
			value: null,
		},
	],
};

// lista da tabela de detalhes da view inicial
export const fieldListPrimary: any = {
	primary: [],
	secondary: [],
};

// lista do modal de edicao
export const fieldList: any = {
	primary: [],
	secondary: [],
};

const fillfieldListPrimary = () => {
	const fieldsCopy = JSON.parse(JSON.stringify(field));
	fieldsCopy.fields.map((i) => {
		switch (i.entityKey) {
			case 'typeLabel':
				fieldList.primary.push(i);
				fieldListPrimary.primary.push(i);
				return;
			case 'dateReference': {
				fieldListPrimary.primary.push(i);

				const changeProperties = JSON.parse(JSON.stringify(i));
				changeProperties.editable = true;

				fieldList.primary.push(changeProperties);
				return;
			}
			case 'risk': {
				fieldListPrimary.primary.push(i);

				const changePropertiesRisk = JSON.parse(JSON.stringify(i));
				changePropertiesRisk.size = 0;

				fieldList.primary.push(changePropertiesRisk);

				return;
			}
		}

		if (i.entityKey === 'description') {
			fieldList.secondary.push(i);
			fieldListPrimary.secondary.push(i);
		}

		if (i.type === 'ADDITIONAL_VALUES') {
			fieldList.secondary.push(i);

			const changeProperties = JSON.parse(JSON.stringify(i));
			changeProperties.type = 'ADDITIONAL_VALUES_CONDENSED';

			fieldListPrimary.secondary.push(changeProperties);

			const primaryVal_1: any = i.fields.find((primary) => primary.entityKey === 'hasPrimary');
			primaryVal_1.fields.map((i) =>
				i.find((z) => {
					if (z.entityKey === 'primaryValue') {
						fieldList.primary.push(z);
						fieldListPrimary.primary.push(z);
					}
				}),
			);
		}
	});

	const riskCalculate = {
		entityKey: 'riskCalculate',
		disabled: true,
		label: 'Risco envolvido',
		size: 3,
		type: 'TEXT',
		mask: 'CURRENCY_BR',
		required: true,
		value: null,
	};

	fieldList.primary.push(riskCalculate);
	fieldListPrimary.primary.push(riskCalculate);
};

fillfieldListPrimary();
